import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: `-${SMALL_MARGIN}px`,
      marginRight: `-${SMALL_MARGIN}px`,
      width: `calc(100% + ${SMALL_MARGIN}px)`,
      [theme.breakpoints.up('xl')]: {
        width: 318,
      },
    },
    index: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: '20px',
      cursor: 'pointer',
      marginRight: SMALL_MARGIN,
      marginBottom: SMALL_MARGIN,
      width: 27,
      '&$active': {
        color: colorsPalette.blue,
      },
      '&$disabled': {
        color: alpha(colorsPalette.white, 0.33),
        cursor: 'default',
      },
      [theme.breakpoints.up('xl')]: {
        width: `calc((100% - ${SMALL_MARGIN * 7}px) / 7)`,
      },
    },
    active: {},
    disabled: {},
  }),
);

export default useStyles;
